import { useState } from "react";
import questions from "./data/questions.json";

import StartScreen from "./screens/StartScreen";
import QuestionScreen from "./screens/QuestionScreen";
import ResultScreen from "./screens/ResultScreen";

export default function App() {
  const MULTI_SELECT_QUESTIONS = ["q2", "q3", "q4"];

  const [step, setStep] = useState("start");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});

  const startQuiz = () => {
    setStep("quiz");
    setCurrentIndex(0);
    setAnswers({});
  };

  const resetQuiz = () => {
    setStep("start");
    setCurrentIndex(0);
    setAnswers({});
  };

  const goToNextQuestion = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex((i) => i + 1);
    } else {
      setStep("result");
    }
  };

  const goToPreviousQuestion = () => {
    if (currentIndex > 0) {
      setCurrentIndex((i) => i - 1);
    }
  };

  const handleAnswer = (questionId, optionKey) => {
    const isMulti = MULTI_SELECT_QUESTIONS.includes(questionId);

    setAnswers((prev) => {
      if (!isMulti) {
        return { ...prev, [questionId]: optionKey };
      }

      const current = prev[questionId] || [];
      const exists = current.includes(optionKey);

      return {
        ...prev,
        [questionId]: exists
          ? current.filter((k) => k !== optionKey)
          : [...current, optionKey],
      };
    });

    if (!isMulti) {
      goToNextQuestion();
    }
  };

  if (step === "start") {
    return <StartScreen onStart={startQuiz} />;
  }

  if (step === "quiz") {
    return (
      <QuestionScreen
        question={questions[currentIndex]}
        answers={answers}
        onAnswer={handleAnswer}
        onNext={goToNextQuestion}
        onBack={goToPreviousQuestion}
        current={currentIndex}
        total={questions.length}
      />
    );
  }

  return <ResultScreen answers={answers} onRestart={resetQuiz} />;
}
